// extracted by mini-css-extract-plugin
export default {"container":"Back_container__MUPHk","show":"Back_show__vNUaJ"};